import { META_PIXEL_ID } from '../data/analytics'
import { PRICE } from '../data/checkout'

/** Shared product parameters for every Meta Pixel commerce event. */
export const PRODUCT_EVENT_PARAMS = {
  content_name: 'WELDING PROJECT PLANS',
  content_category: 'Digital Product',
  content_type: 'product',
  value: PRICE.value,
  currency: PRICE.currency,
} as const

/** Milliseconds during which a repeated InitiateCheckout click is ignored. */
const CHECKOUT_DEBOUNCE_MS = 1500

let viewContentSent = false
let lastCheckoutSentAt = 0

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the Meta Pixel base code once. Does nothing until a Welding pixel
 * ID is configured in data/analytics.ts. Purchase events are intentionally
 * never fired from button clicks.
 */
export function initMetaPixel(): void {
  if (!META_PIXEL_ID) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  /* eslint-disable */
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
  /* eslint-enable */

  // The <noscript> fallback is intentionally NOT created from JavaScript: a
  // script-built <noscript> loads its <img> while JS is enabled and Meta would
  // receive a second PageView. It only works as static markup in index.html:
  // <noscript><img height="1" width="1" style="display:none"
  //   src="https://www.facebook.com/tr?id=1705136450541998&ev=PageView&noscript=1" /></noscript>
  // Defensive cleanup of any legacy script-injected node from the old fork.
  document.getElementById('meta-pixel-noscript')?.remove()

  trackViewContent()
}

/** Fires ViewContent once per page load for the product page. */
export function trackViewContent(): void {
  if (typeof window === 'undefined' || viewContentSent || !window.fbq) return
  viewContentSent = true
  window.fbq('track', 'ViewContent', { ...PRODUCT_EVENT_PARAMS })
}

/** Fires InitiateCheckout, ignoring rapid repeated clicks. */
export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined' || !window.fbq) return

  const now = Date.now()
  if (now - lastCheckoutSentAt < CHECKOUT_DEBOUNCE_MS) return
  lastCheckoutSentAt = now

  window.fbq('track', 'InitiateCheckout', { ...PRODUCT_EVENT_PARAMS })
}
